<template src='./duplicateMovements.pug' lang='pug'></template>

<script>
import moment from 'moment'
import DateRange from '../../input/dateRange/DateRange'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import language from '../../../../build/language/index'

export default {
  name: 'DuplicateMovements',

  components: {
    DateRange,
    ButtonPrimary
  },

  props: {
    disableSearchButton: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      language: language,
      dateRange: {},
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),
      comparableFieldsList: [
        {
          id: 'H',
          nome: this.$t('analiseDuplicidade.labels.camposAvaliados.historico'),
          checked: true
        },
        {
          id: 'C',
          nome: this.$t('analiseDuplicidade.labels.camposAvaliados.complemento'),
          checked: true
        },
        {
          id: 'T',
          nome: this.$t('analiseDuplicidade.labels.camposAvaliados.fitid'),
          checked: true
        },
        {
          id: 'D',
          nome: this.$t('analiseDuplicidade.labels.camposAvaliados.documento'),
          checked: true
        }
      ],
      selectedFields: ['H', 'C', 'T', 'D']
    }
  },

  watch: {
    comparableFieldsList: {
      handler (val) {
        this.selectedFields = []
        val.forEach(st => {
          if (st.checked) {
            this.selectedFields.push(st.id)
          }
        })
      },
      deep: true
    }
  },

  methods: {
    validate () {
      const self = this
      this.$validator.validateAll().then((result) => {
        if (result && self.$refs.dateRange.validate()) {
          const searchData = {
            gridId: 'LancamentoDuplicado',
            actionName: 'searchDuplicateMovements',
            filter: {
              inicio: self.dateRange.fromDate,
              fim: self.dateRange.toDate,
              avaliarHistorico: self.selectedFields.includes('H'),
              avaliarDsComplemento: self.selectedFields.includes('C'),
              avaliarNRFITID: self.selectedFields.includes('T'),
              avaliarNrDocumento: self.selectedFields.includes('D'),
              lang: language.getCookieByName('language')
            }
          }

          this.$emit('search-movements', searchData)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// DuplicateMovements.vue?5a2867c7